<div
  fxLayout="row"
  fxLayoutAlign="center start"
  class="centered-container"
  fxFlexFill
>
  <mat-card
    class="login-card mat-elevation-z4"
    ngClass.gt-xs="larger-margins"
    fxLayout="column"
    fxLayoutAlign="space-around stretch"
    fxFlex="100"
    fxFlex.gt-xs="50"
  >
    <h1 class="title">Log In with Phone</h1>
    <form
      [formGroup]="form"
      class="login-form"
      fxLayout="column"
      fxLayoutAlign="start center"
      (ngSubmit)="signUp()"
      *ngIf="confirmationResult == null"
    >
      <mat-form-field fxFill class="phone-field">
        <mat-label>Phone Number</mat-label>
        <span matPrefix>+27 &nbsp;</span>
        <mat-icon matSuffix>phone</mat-icon>
        <input
          matInput
          formControlName="phoneNumber"
          placeholder="87 123 4567"
          type="tel"
        /><mat-error *ngIf="form.get('phoneNumber')?.hasError('required')">
          Phone Number is required.
        </mat-error>
        <mat-error *ngIf="form.get('phoneNumber')?.hasError('pattern')">
          Please enter a valid phone number.
        </mat-error>
      </mat-form-field>
      <button
        id="sign-in-button"
        class="form-button"
        [class.spinner]="loading"
        [disabled]="loading"
        mat-raised-button
        fxFill
        color="primary"
        type="submit"
      >
        Log In
      </button>
    </form>
    <form
      *ngIf="confirmationResult != null"
      [formGroup]="confirmationForm"
      (ngSubmit)="confirm()"
      class="login-form"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <div class="info-container">
        <p>
          A six (6) digit confirmation code has been sent to your number
          <strong>{{ internationalizedPhoneNumber }}</strong
          >. Please check your SMSs and enter the code below.
        </p>
      </div>

      <mat-form-field fxFill class="form-field">
        <mat-label>Confirmation Code</mat-label>
        <input matInput formControlName="confirmationCode" /><mat-error
          *ngIf="confirmationForm.get('confirmationCode')?.hasError('required')"
        >
          Confirmation Code is required. </mat-error
        ><mat-error
          *ngIf="confirmationForm.get('confirmationCode')?.hasError('pattern')"
        >
          Your confirmation code will be 6 digits and will not contain any
          letters.
        </mat-error>
        <mat-icon matSuffix>fiber_pin</mat-icon>
        <mat-hint>The code will look something like '123456'.</mat-hint>
      </mat-form-field>
      <button
        id="confirm-button"
        class="form-button"
        [class.spinner]="loading"
        [disabled]="loading"
        mat-raised-button
        fxFill
        color="primary"
        type="submit"
      >
        Confirm
      </button>
    </form>
    <div>
      Prefer to login another way?
      <a routerLink="../">Login Menu</a>
    </div>
    <div>Don't have an account? <a routerLink="/signup">Register</a></div>
  </mat-card>
</div>
